import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function showContentOutlineInPreviewReducer(state = initialState.showContentOutlineInPreview, action) {
    switch(action.type){
        case types.SET_SHOW_CONTENT_OUTLINE_IN_PREVIEW:
            //debugger;
            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new stateconsole.log('UPDATE_PROJECT_SUCCESS')
            return action.showContentOutlineInPreview;

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/showContentOutlineInPreviewReducer.js
 **/